export default __webpack_public_path__ + "static/media/devpost.44cfb0bf.svg";